document.addEventListener('DOMContentLoaded', function () {
    var charLimit = 100;
    var paragraphs = document.querySelectorAll('.shop__subheading .shop__container--subheading p');

    for (var i = 0; i < paragraphs.length; i++) {
        (function (p) {
            var fullText = p.textContent.trim();
            var fullHTML = p.innerHTML;

            if (fullText.length <= charLimit) {
                return;
            }

            var shortText = fullText.slice(0, charLimit).trim() + '…';

            var textSpan = document.createElement('span');
            textSpan.className = 'shop__subheading-text';
            textSpan.textContent = shortText;

            var toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'shop__subheading-toggle';
            toggle.textContent = 'Read more';

            while (p.firstChild) {
                p.removeChild(p.firstChild);
            }

            p.appendChild(textSpan);
            p.appendChild(document.createTextNode(' '));
            p.appendChild(toggle);

            toggle.addEventListener('click', function () {
                var expanded = toggle.textContent === 'Read less';

                if (expanded) {
                    textSpan.textContent = shortText;
                    toggle.textContent = 'Read more';
                } else {
                    textSpan.innerHTML = fullHTML;
                    toggle.textContent = 'Read less';
                }
            });
        })(paragraphs[i]);
    }
});